/** Shared by line-form's and multiline-chart's `chartStyle: 'area'` rendering,
 * so the two never drift apart. Row/series shaping, units and tooltips stay
 * with each form; this is only the gradient and the `Area`/chart look. */

/** `AreaChart`/`LineChart` margin both forms draw their small cards at. */
export const CHART_MARGIN = { top: 8, right: 12, left: 0, bottom: 4 };

/** A point with a gap (or the series edge) on both sides has no segment to
 * draw and would vanish, so it alone gets a dot. */
const renderIsolatedPointDot = ({
    cx,
    cy,
    index,
    points,
    stroke,
}: {
    cx?: number;
    cy?: number;
    index: number;
    points: readonly { y: number | null }[];
    stroke?: string;
}) =>
    cy != null &&
    points[index - 1]?.y == null &&
    points[index + 1]?.y == null ? (
        <circle cx={cx} cy={cy} r={3} fill={stroke} />
    ) : null;

/** Non-animation `Area` styling; the animation props (`isAnimationActive` and
 * friends) stay literal on each `Area`, not spread from here. */
export const AREA_STYLE_PROPS = {
    type: 'monotone',
    strokeWidth: 2,
    dot: renderIsolatedPointDot,
    activeDot: { r: 4 },
} as const;

/** One vertical gradient, solid near the line and fading to nothing by the
 * baseline. */
export const AreaGradientDef = ({
    id,
    color,
}: {
    id: string;
    color: string;
}) => (
    <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor={color} stopOpacity={0.35} />
        <stop offset="100%" stopColor={color} stopOpacity={0.02} />
    </linearGradient>
);
